  import React, { useMemo } from "react";
import { TextureLoader } from "three";
import Window from "../assets/Window.png";
import Door from "../assets/Door.png";
import Railing from "../assets/Railing.png";
import New from "../assets/New.png";
import Wall from "../assets/Walll.png";
import HiddenWall from "../assets/hiddenwall.png";
import Opening from "../assets/Opening.png";
import newWall from "../assets/newWall.png";
import newWall2 from "../assets/newWall2.png";
import updatedWall from "../assets/updatedWall.png"
import updatedWindow from "../assets/updatedWindow.png";
import updatedDoor from "../assets/updatedDoor.png";
import updatedRailing from "../assets/updatedRailing.png";
import updatedOpening from "../assets/updatedOpening.png";
import updatedWallHover from "../assets/updatedWallHover.png";
import updatedWindowHover from "../assets/updatedWindowHover.png";
import slidingDoorHover from "../assets/sliding_door_hover.png";
import slidingDoor from "../assets/sliding_door.png";
import updatedDoorHover from "../assets/updatedDoorHover.png";
import updatedRailingHover from "../assets/updatedRailingHover.png";
import updatedOpeningHover from "../assets/updatedOpeningHover.png";
import updatedSelected from "../assets/updatedSelected.png";
import firstLine from "../assets/firstLine.png";

const useTexture = () => {
  const textureLoader = useMemo(() => new TextureLoader(), []);

  const windowTexture = useMemo(
    () => textureLoader.load(updatedWindow),
    [textureLoader]
  );
  const slidingDoorTexture = useMemo(
    () => textureLoader.load(slidingDoor),
    [textureLoader]
  );

  const selectedTexture = useMemo(
    () => textureLoader.load(updatedSelected),
    [textureLoader]
  );

  const railingTexture = useMemo(
    () => textureLoader.load(updatedRailing),
    [textureLoader]
  );

  const doorTexture = useMemo(() => textureLoader.load(updatedDoor), [textureLoader]);

  const wallTexture = useMemo(() => textureLoader.load(updatedWall), [textureLoader]);

  const windowTextureHover = useMemo(
    () => textureLoader.load(updatedWindowHover),
    [textureLoader]
  );

  const slidingDoorTextureHover = useMemo(
    () => textureLoader.load(slidingDoorHover),
    [textureLoader]
  );

  const railingTextureHover = useMemo(
    () => textureLoader.load(updatedRailingHover),
    [textureLoader]
  );
  const doorTextureHover = useMemo(
    () => textureLoader.load(updatedDoorHover),
    [textureLoader]
  );
  const wallTextureHover = useMemo(
    () => textureLoader.load(updatedWallHover),
    [textureLoader]
  );
  const openingTextureHover = useMemo(
    () => textureLoader.load(updatedOpeningHover),
    [textureLoader]
  );

  const hiddenWallTexture = useMemo(
    () => textureLoader.load(updatedOpening),
    [textureLoader]
  );

  const hoveredTexture = useMemo(
    () => textureLoader.load(Opening),
    [textureLoader]
  );

  const firstLineTexture = useMemo(
    () => textureLoader.load(firstLine),
    [textureLoader]
  );

  return {
    windowTexture,
    selectedTexture,
    railingTexture,
    doorTexture,
    wallTexture,
    hiddenWallTexture,
    hoveredTexture,
    windowTextureHover,
    railingTextureHover,
    doorTextureHover,
    wallTextureHover,
    openingTextureHover,
    firstLineTexture,
    slidingDoorTexture,
    slidingDoorTextureHover,
  };
};

export default useTexture;
